export const FadeInVisible = {
  data() {
    return {
      visible: false
    };
  },
  created(){
    this.fadeInVisible();
  },
  methods: {
    fadeInVisible() {
        this.visible = !this.visible
    }
  }
}